import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GenericDialog } from '@app/shared/models/generic-dialog.model';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { ModalTerminosUsoComponent } from '../modal-terminos-uso/modal-terminos-uso.component';

@Component({
  selector: 'dhl-modal-downland-print',
  templateUrl: './modal-downland-print.component.html',
  styleUrls: ['./modal-downland-print.component.scss']
})
export class ModalDownlandPrintComponent {
  dialogData: GenericDialog;

  constructor(public dialogRef: MatDialogRef<GenericDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialog, public dialog: MatDialog,) {
    this.dialogData = data;
  }

  /**
   * On Accept dialog generic action
   */
  onAccept(): void {
    this.dialogRef.close(true);
  }

  /**
   * On Cancel dialog generic action
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }
   // Modal Terminos y condiciones
   async redirectToTerms() {
    const dialogRef = this.dialog.open(ModalTerminosUsoComponent, {
      data: {
        title: 'Términos y condiciones de uso',
        message: '',
        acceptLabel: 'Cerrar',
        showAccept: true
      }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      return result;
    });
  }

}
